import { medicationPath, notePath, reportPath, vitalPath } from '../constants/routes';

export function getNoteDetailRoute(note) {
  if (!note?.id || !note?.note_type) return null;

  switch (note.note_type) {
    case 'progress_note':
      return { path: notePath(note.id), state: { note } };
    case 'vitals':
      return { path: vitalPath(note.id), state: { note } };
    case 'medication_admin':
      return { path: medicationPath(note.id), state: { note } };
    case 'handover':
    case 'discharge':
      return {
        path: reportPath(`report-${note.id}`),
        state: {
          report: {
            id: `report-${note.id}`,
            noteId: note.id,
            type: note.note_type === 'handover' ? 'shift_handover' : note.note_type,
            title: note.patient_name || 'Patient',
            patientName: note.patient_name,
            patientId: note.patient_id,
            datetime: note.datetime,
            note,
          },
        },
      };
    default:
      return null;
  }
}
